import { render } from "./Collapse.vue?vue&type=template&id=6b2e5bf6&ts=true"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/janvodila/Sites/sempermed/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__